import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Image from '@components/image'
import { StyleWrapper, StyleNone } from './style'
import { FC, Fragment } from 'react'
import Typography from '@components/typography'
import Svg from '@components/svg'
interface AppointmentSymptomsProps {
  symptoms: any[]
}
const AppointmentSymptoms: FC<AppointmentSymptomsProps> = ({ symptoms }) => {
  return (
    <Column
      bg="white"
      styleColumn="padding:20px;border-radius:12px;"
      rowGap={15}
    >
      <CardHeading title="Patient Symptoms" tc="primary" />
      <StyleWrapper>
        {!symptoms?.length ? (
          <Column rowGap={5} alignItems="center">
            <StyleNone>
              <Svg svg="none" />
            </StyleNone>
            <Typography content={'None'} size={12} tc="text100" />
          </Column>
        ) : (
          <>
            {symptoms?.map((symptom: any) => {
              return (
                <Fragment key={symptom?.id}>
                  <Column rowGap={5} alignItems="center">
                    <Image
                      styleImage="border-radius:50%"
                      src={`${process.env.BUCKET_URL}/${symptom?.image}`}
                      width={50}
                      height={50}
                    />
                    <Typography content={symptom?.name} size={14} />
                  </Column>
                </Fragment>
              )
            })}
          </>
        )}
      </StyleWrapper>
    </Column>
  )
}
export default AppointmentSymptoms
